module.exports = __webpack_public_path__ + "resources/logo-leto-bank.png";